import { useContext } from "react";

import { Context } from "../../managerStore";

const useSchoolStatus = () => {
  const { state } = useContext(Context);
  const school = state.manager?.school;

  const isCramSchool = school?.use_case === "cram_school";

  const isCurrentYearChangeOpen = school?.change_current_year_status === "open";

  return { isCramSchool, isCurrentYearChangeOpen };
};

export default useSchoolStatus;
